import { OrderStateEnum } from '@bo-client/shared/models/orderRequestDto';
import { isUiAdaptionShown, StatusAvailabilityContext, StatusRuleSet } from '../status-availability.model';

/** Mandanteneinstellung „Aufträge automatisch in Abrechnungssystem schreiben“. */
const ordersAutomatically = (ctx: StatusAvailabilityContext): boolean => !!ctx.tenant?.canOrderAutomatically;

/** Hausanschluss (Status der Anfrage): Status, die nicht jeder Mandant über einen Prozessschritt erreicht. */
export const ORDER_REQUEST_STATUS_RULES: StatusRuleSet = {
  blacklist: {
    [OrderStateEnum.Placed]: ordersAutomatically,
    [OrderStateEnum.ErrorCreatingOrder]: ordersAutomatically,
    [OrderStateEnum.Confirmed]: (ctx) => !ordersAutomatically(ctx),
    [OrderStateEnum.Approved]: (ctx) => isUiAdaptionShown(ctx, 'or_canRequestApproval'),
    [OrderStateEnum.TechnicallyCompleted]: (ctx) =>
      isUiAdaptionShown(ctx, 'or_canCompleteTechAction') ||
      isUiAdaptionShown(ctx, 'or_canCompleteTechActionV2'),
    [OrderStateEnum.CommerciallyCompleted]: (ctx) => isUiAdaptionShown(ctx, 'or_canCompleteAction'),
    [OrderStateEnum.Canceled]: (ctx) => isUiAdaptionShown(ctx, 'or_canCancel'),
    [OrderStateEnum.CreatingSap]: null,
    [OrderStateEnum.InProgress]: null,
    [OrderStateEnum.UnderConstruction]: null,
    rejected: null,
    // Eintrag „Alle“ der Status-Dropdowns, kein Status.
    '': null
  }
};
